"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoginForm = _interopRequireDefault(require("./LoginForm"));

var _antd = require("antd");

var _reactRedux = require("react-redux");

var backgroundStyle = {
  backgroundImage: 'url(/clPortal/img/others/img-17.jpg)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover'
};

var LoginOne = function LoginOne(props) {
  var theme = (0, _reactRedux.useSelector)(function (state) {
    return state.theme.currentTheme;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-100",
    style: backgroundStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container d-flex flex-column justify-content-center h-100"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 20,
    sm: 20,
    md: 20,
    lg: 7
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "my-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "img-fluid",
    src: "/clPortal/img/".concat(theme === 'light' ? 'Saarthi-blue.png' : 'Saarthi-White.png'),
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("p", null, "Welcome to Saarthi CL Portal")), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 20,
    lg: 20
  }, /*#__PURE__*/_react.default.createElement(_LoginForm.default, props)))))))));
};

var _default = LoginOne;
exports.default = _default;